var a = /* @__PURE__ */ ((r) => (r.BIG = "big", r.SMALL = "small", r))(a || {}), l = /* @__PURE__ */ ((r) => (r.WITH_IMAGE = "with-image", r.NORMAL = "normal", r))(l || {});
export {
  l as RocheUIQuoteLayout,
  a as RocheUIQuoteSize
};
